module.exports = __webpack_public_path__ + "static/img/38-3.dd7cb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/38-3.jpg
// module id = EEkA
// module chunks = 0